import * as Sentry from '@sentry/react';

type PlausibleFn = (event: string, opts?: { props?: Record<string, string | number | boolean> }) => void;

function getPlausible(): PlausibleFn | undefined {
  if (typeof window === 'undefined') return undefined;
  return (window as unknown as { plausible?: PlausibleFn }).plausible;
}

/** Privacy-friendly analytics — no user IDs or emails in props. */
export function trackEvent(name: string, props?: Record<string, string | number>) {
  const plausible = getPlausible();
  if (!plausible) return;
  try {
    if (props && Object.keys(props).length > 0) {
      plausible(name, { props: props as Record<string, string | number | boolean> });
    } else {
      plausible(name);
    }
  } catch {
    // ignore
  }
}

export function analyticsBreadcrumb(
  category: string,
  message: string,
  data?: Record<string, unknown>,
) {
  try {
    Sentry.addBreadcrumb({
      category,
      message,
      level: 'info',
      data: data as Record<string, string | number | boolean | null | undefined> | undefined,
    });
  } catch {
    // ignore
  }
}
